import React from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import spinner from "assets/graphics/icons/spinner.svg";
import "./view.scss";

const variants = {
  open: {
    visibility: "visible",
    opacity: 1,
  },
  closed: {
    opacity: 0,
    transitionEnd: {
      display: "none",
    },
  },
};

export const Loader = ({ isOpen }) => {
  return (
    <motion.div
      animate={isOpen ? "open" : "closed"}
      variants={variants}
      className="loader__overlay"
      transition={{
        duration: 1,
      }}
    >
      <img className="loader__spinner" src={spinner} alt="spinner" />
    </motion.div>
  );
};

Loader.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};
